import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useAllProjects } from "../../../hooks/DevProjectHooks";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import Sidebar from "../../../components/consolecomponents/sidebar/Sidebar";
import IsLoading from "../../../util/loader/IsLoading";
import FormikControl from "../../../util/formcomponents/FormikControl";
import ConsoleLocalStorage from "../../../storage/storage";
import ComingSoonModal from "../../../components/consolecomponents/modal/ComingSoonModal";

import arrowdown from "../../../Assets/arrowdown.svg";
import edit from "../../../Assets/organization/edit.svg";
import styles from "./OrganizationDashboard.module.scss";
import cover from "../../../Assets/organization/cover.jpg";
import profile from "../../../Assets/organization/profile.png";
import orgSwitch from "../../../Assets/organization/org-switch.svg";
import orgDetails from "../../../Assets/organization/org-details.svg";
import OrgUploadModal from "../../../components/consolecomponents/modal/OrgUploadModal";
import { useGetOrg } from "../../../hooks/DevConsoleHooks";

const onSubmit = () => {
  console.log("my profile form submitted");
};

const OrganizationDashboard = () => {
  const [showSideBarList, setShowSidebarList] = useState(false);
  const history = useHistory();
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [showOrgUploadModal, setShowOrgUploadModal] = useState(false);
  const [isCover, setIsCover] = useState(false);

  const initialValues = {
    name: ConsoleLocalStorage.getOrganization().name,
    website: ConsoleLocalStorage.getOrganization().website,
    publisherName: ConsoleLocalStorage.getOrganization().publisherName,
    addr1: ConsoleLocalStorage.getOrganization().address.address1,
    addr2: ConsoleLocalStorage.getOrganization().address.address2,
    country: ConsoleLocalStorage.getOrganization().address.country,
    state: ConsoleLocalStorage.getOrganization().address.state,
    city: ConsoleLocalStorage.getOrganization().address.city,
    aboutUs: ConsoleLocalStorage.getOrganization().name,
  };
  /**
   * All projects for sidebar dropdown
   */
  const {
    data: projects,
    isLoading: projectsLoading,
    isError: projectsError,
  } = useAllProjects();

 
 const userData= ConsoleLocalStorage.getUser();
  /**
   * Org data
   */
  const {
    data: org,
    isLoading: orgLoading,
    isError: orgError,
  } = useGetOrg(ConsoleLocalStorage.getOrganization().id);

  if (projectsLoading || orgLoading) {
    return <IsLoading />;
  }
  if (projectsError || orgError) {
    history.push("/login");
    return <IsLoading />;
  }
  return (
    <>
      <OrgUploadModal
        showOrgUploadModal={showOrgUploadModal}
        setShowOrgUploadModal={setShowOrgUploadModal}
        isCover={isCover}
      />

      <ComingSoonModal
        showComingSoon={showComingSoon}
        setShowComingSoon={setShowComingSoon}
      />
      <div className={styles.organization}>
        <Sidebar>
          <section className="">
            <div
              onClick={() => setShowSidebarList(!showSideBarList)}
              className="sidebar_projects"
            >
              <h3 className="">
                {`All Projects (${projects?.length})`}
                <img
                  src={arrowdown}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </h3>
              {showSideBarList ? (
                <ul className="sidebar_projectlist">
                  {projects.map((project) => (
                    <li key={project.id}>
                      <Link to={`/console/${project.id}`}>
                        <span className="sidebar_list_items">
                          {project.name}
                        </span>{" "}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
        </Sidebar>
        <div className={styles.main}>
          <div className={styles.body}>
            <div className={styles.tabs}>
              <span className={styles.highlight}>
                <img src={orgDetails} alt="" />
                Organization Details
              </span>
              <span onClick={() => setShowComingSoon(true)}>
                <img src={orgSwitch} alt="" />
                Switch Organization
              </span>
            </div>
            <div>
              <div className={styles.orgdetails}>
                <span className={styles.cover}>
                  <span className={styles.coveredit}>
                    <span className={userData?.roles[0]?.name!=="owner"?'d-none':''}
                      onClick={() => {
                        setIsCover(true);
                        setShowOrgUploadModal(true);
                      }}
                    >
                      <img
                        src={edit}
                        alt="edit"
                        style={{ height: "1.25rem", marginRight: "0.5rem" }}
                      />
                      Edit
                    </span>
                  </span>
                  <img
                    src={org.banner ? org.banner : cover}
                    className={styles.coverimg}
                    alt="cover photo"
                  />
                </span>
                <span
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <span className={styles.profile}>
                    <img
                      src={org.logo ? org.logo : profile}
                      className={styles.profileimg}
                      alt="profile photo"
                    />
                    <span
                      className={`${styles.profileedit} ${userData?.roles[0]?.name!=="owner"?'d-none':''} `}
                      onClick={() => {
                        setIsCover(false);
                        setShowOrgUploadModal(true);
                      }}
                    >
                      <span>
                        <img
                          src={edit}
                          alt="edit"
                          style={{ height: "1.25rem", marginRight: "0.5rem" }}
                        />
                        Edit
                      </span>
                    </span>
                  </span>
                </span>
                <div style={{ padding: "1rem" }}>
                  <Formik
                    initialValues={org}
                    // validationSchema={validationSchema}
                    onSubmit={onSubmit}
                  >
                    {(formik) => {
                      // console.log(formik);
                      return (
                        <Form>
                          <FormikControl
                            control="input"
                            type="text"
                            required={false}
                            label="Company/Organization Name"
                            name="name"
                            disabled
                          />
                          <FormikControl
                            control="input"
                            type="text"
                            required={false}
                            label="Company Website"
                            name="website"
                            disabled
                          />
                          <FormikControl
                            control="input"
                            type="text"
                            required={false}
                            label="Publisher Name"
                            name="publisherName"
                            disabled
                          />
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "48% 48%",
                              gap: "1em",
                              width: "100%",
                            }}
                          >
                            <span>
                              <FormikControl
                                control="input"
                                type="text"
                                required={false}
                                label="Address Line 1"
                                name="address.address1"
                                disabled
                              />
                            </span>
                            <span>
                              <FormikControl
                                control="input"
                                type="text"
                                required={false}
                                label="Address Line 2"
                                name="address.address2"
                                disabled
                              />
                            </span>
                          </div>

                          <FormikControl
                            control="input"
                            type="text"
                            required={false}
                            label="Country"
                            name="address.country"
                            disabled
                          />
                          <FormikControl
                            control="input"
                            type="text"
                            required={false}
                            label="State"
                            name="address.state"
                            disabled
                          />
                          <FormikControl
                            control="input"
                            type="text"
                            required={false}
                            label="City"
                            name="address.city"
                            disabled
                          />
                          <FormikControl
                            control="input"
                            type="text"
                            required={false}
                            label="About Us"
                            name="description"
                            disabled
                          />
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
              <span className={styles.note}>
                NOTE: To edit any details in Organization contact JioTesseract
                admin.
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrganizationDashboard;
